import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRef } from 'vue'

import RentalForm from './RentalForm.vue'
import RentalListItem from './RentalListItem.vue'
import LButton from '@/components/core/Button.vue'
import { useListRentals, useDeleteRental } from '@/composables/transportation'
import { useSelectedTrip } from '@/composables/trip'
import type {
  DrivingTransportationUIInput,
  Rental,
} from '@/types/transportation'


export default /*#__PURE__*/_defineComponent({
  __name: 'RentalManager',
  props: {
    transportation: null
  },
  emits: ["input"],
  setup(__props: any) {

const props = __props as {
  transportation: DrivingTransportationUIInput
};

const modeTypes = ['add', 'edit', 'list', 'closed'] as const





const transportation = toRef(props, 'transportation')

const previousMode = ref<(typeof modeTypes)[number]>('closed')
const currentMode = ref<(typeof modeTypes)[number]>('closed')
const mode = computed({
  get() {
    return currentMode.value
  },
  set(value) {
    previousMode.value = currentMode.value
    currentMode.value = value
  },
})
const editRental = ref<Rental | null>(null)

const trip = useSelectedTrip()
const { data: rentals, isLoading } = useListRentals(trip.value._id)
const { mutateAsync: deleteRental } = useDeleteRental(trip.value._id)

const linkedRental = computed(() => {
  const rentalId = transportation.value.rentals[0]
  return rentals.value.find((rental) => rental._id === rentalId)
})

function linkOrUnlinkRental(rental: Rental) {
  if (transportation.value.rentals.includes(rental._id)) {
    unlinkRental()
  } else {
    linkRental(rental)
  }
}

function linkRental(rental: Rental) {
  transportation.value.rentals = [rental._id]
  mode.value = 'closed'
}

function unlinkRental() {
  transportation.value.rentals = []
  mode.value = 'closed'
}

function handleEditRental(rental: Rental) {
  editRental.value = rental
  mode.value = 'edit'
}

async function handleDeleteRental(rental: Rental) {
  await deleteRental(rental._id)
}

function handleCancel() {
  mode.value = previousMode.value
  editRental.value = null
}

function handleSaved(rental: Rental) {
  transportation.value.rentals = [rental._id]
  mode.value = 'closed'
}

function handlePlaceholderClick() {
  // Directly open the form to add a new rental, when there are no rentals for
  // the trip.
  if (!isLoading.value && !rentals.value.length) {
    mode.value = 'add'
  } else {
    mode.value = 'list'
  }
}

return { __sfc: true,modeTypes, props, transportation, previousMode, currentMode, mode, editRental, trip, rentals, isLoading, deleteRental, linkedRental, linkOrUnlinkRental, linkRental, unlinkRental, handleEditRental, handleDeleteRental, handleCancel, handleSaved, handlePlaceholderClick, RentalForm, RentalListItem, LButton }
}

})